<template lang="pug">
div
  .md-headline Pricing
  md-layout(v-for='(pricing, index) in entity.pricing', :key='index', :md-gutter='24')
    md-layout(md-flex='50', md-flex-small='100')
      price-unit-selector(v-model='entity.pricing[index].unit')
    md-layout(md-flex='50', md-flex-small='100')
      price-input(v-model='entity.pricing[index].price')
</template>

<script>
  import PriceUnitSelector from '../../shared-components/pricing/PricingUnitSelector';
  import PriceInput from '../../shared-components/pricing/PriceInput';

  export default {
    components: {
      PriceUnitSelector,
      PriceInput
    },
    props: {
      entity: {
        type: Object,
        required: true
      }
    }
  };
</script>

<style lang="scss" scoped>
  .md-headline {
    margin-bottom: 15px;
  }
  .remove-pricing {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/PricingForm.vue